import { render, staticRenderFns } from "./EditFabricRolls.vue?vue&type=template&id=6eade952"
import script from "./EditFabricRolls.vue?vue&type=script&lang=js"
export * from "./EditFabricRolls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports